import React, { useState, useEffect } from 'react';
import { getMySubjects, getSubjectStudents, markAttendance } from '../../api';
import { toast } from 'react-toastify';

const MarkAttendance = () => {
  const [subjects, setSubjects] = useState([]);
  const [students, setStudents] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [attendance, setAttendance] = useState({});

  useEffect(() => { loadSubjects(); }, []);

  const loadSubjects = async () => {
    try {
      const res = await getMySubjects();
      setSubjects(res.data);
    } catch (err) {
      toast.error('Error loading subjects');
    }
  };

  const loadStudents = async (subjectId) => {
    try {
      const res = await getSubjectStudents(subjectId);
      setStudents(res.data);
      const initial = {};
      res.data.forEach(s => initial[s.id] = 'present');
      setAttendance(initial);
    } catch (err) {
      toast.error('Error loading students');
    }
  };

  const handleSubjectChange = (e) => {
    setSelectedSubject(e.target.value);
    if (e.target.value) loadStudents(e.target.value);
  };

  const handleStatus = (studentId, status) => {
    setAttendance(prev => ({...prev, [studentId]: status}));
  };

  const handleSubmit = async () => {
    if (!selectedSubject) return toast.error('Select a subject!');
    try {
      const attendanceList = Object.keys(attendance).map(id => ({
        student_id: id, status: attendance[id]
      }));
      await markAttendance({ subject_id: selectedSubject, date, attendance: attendanceList });
      toast.success('Attendance marked successfully!');
      setStudents([]);
      setSelectedSubject('');
    } catch (err) {
      if (err.response?.status === 400) {
        toast.error(err.response.data.message); // "Aaj ki attendance pehle se le li gayi hai"
      } else {
        toast.error('Error marking attendance');
      }
    }
  };

  const countStatus = (status) => Object.values(attendance).filter(s => s === status).length;

  return (
    <div>
      <h3 style={styles.title}>✅ Mark Attendance</h3>

      <div style={styles.filterCard}>
        <div style={styles.filterGrid}>
          <div>
            <label style={styles.label}>Select Subject</label>
            <select style={styles.input} value={selectedSubject}
              onChange={handleSubjectChange}>
              <option value="">-- Select Subject --</option>
              {subjects.map(s => (
                <option key={s.id} value={s.id}>
                  {s.name} - {s.class_name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label style={styles.label}>Date</label>
            <input style={styles.input} type="date" value={date}
              onChange={e => setDate(e.target.value)} />
          </div>
        </div>
      </div>

      {students.length > 0 && (
        <>
          <div style={styles.statsRow}>
            <div style={{...styles.statBadge, background: '#d4edda', color: '#155724'}}>
              Present: {countStatus('present')}
            </div>
            <div style={{...styles.statBadge, background: '#f8d7da', color: '#721c24'}}>
              Absent: {countStatus('absent')}
            </div>
            <div style={{...styles.statBadge, background: '#fff3cd', color: '#856404'}}>
              Leave: {countStatus('leave')}
            </div>
          </div>

          <div style={styles.tableCard}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHeader}>
                  <th style={styles.th}>#</th>
                  <th style={styles.th}>Roll No</th>
                  <th style={styles.th}>Student Name</th>
                  <th style={styles.th}>Present</th>
                  <th style={styles.th}>Absent</th>
                  <th style={styles.th}>Leave</th>
                </tr>
              </thead>
              <tbody>
                {students.map((student, index) => (
                  <tr key={student.id} style={styles.tableRow}>
                    <td style={styles.td}>{index + 1}</td>
                    <td style={styles.td}>{student.roll_number || '-'}</td>
                    <td style={styles.td}>{student.name}</td>
                    <td style={styles.td}>
                      <input type="radio" name={`att_${student.id}`}
                        checked={attendance[student.id] === 'present'}
                        onChange={() => handleStatus(student.id, 'present')}
                        style={styles.radio} />
                    </td>
                    <td style={styles.td}>
                      <input type="radio" name={`att_${student.id}`}
                        checked={attendance[student.id] === 'absent'}
                        onChange={() => handleStatus(student.id, 'absent')}
                        style={styles.radio} />
                    </td>
                    <td style={styles.td}>
                      <input type="radio" name={`att_${student.id}`}
                        checked={attendance[student.id] === 'leave'}
                        onChange={() => handleStatus(student.id, 'leave')}
                        style={styles.radio} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <button style={styles.submitBtn} onClick={handleSubmit}>
            ✅ Submit Attendance
          </button>
        </>
      )}

      {selectedSubject && students.length === 0 && (
        <div style={styles.empty}>No students found in this subject!</div>
      )}
    </div>
  );
};

const styles = {
  title: { color: '#1a6b3a', marginBottom: '20px' },
  filterCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  filterGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '5px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%' },
  statsRow: { display: 'flex', gap: '10px', marginBottom: '15px' },
  statBadge: { padding: '8px 20px', borderRadius: '20px', fontSize: '14px', fontWeight: '600' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', marginBottom: '20px' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHeader: { background: '#1a6b3a' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'left', fontSize: '13px' },
  tableRow: { borderBottom: '1px solid #eee' },
  td: { padding: '12px 15px', fontSize: '13px', color: '#444' },
  radio: { width: '18px', height: '18px', cursor: 'pointer' },
  submitBtn: { padding: '12px 30px', background: '#28a745', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '15px', fontWeight: '600' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
};

export default MarkAttendance;